import { motion } from "framer-motion";

export const MetricCard = ({ 
  label, 
  value, 
  prefix = "", 
  suffix = ""
}) => {
  const formatValue = (val) => {
    if (typeof val === "number") {
      if (val >= 1000) {
        return val.toLocaleString();
      }
      return val.toString();
    }
    return val;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="metric-card p-5 transition-all duration-200"
      data-testid={`metric-card-${label.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
    >
      <div className="space-y-2">
        <p className="text-xs uppercase tracking-wide text-slate-500 font-medium">
          {label}
        </p>
        <p className="text-2xl md:text-3xl font-heading font-bold text-slate-800">
          {prefix}{formatValue(value)}{suffix}
        </p>
      </div>
    </motion.div>
  );
};

export default MetricCard;
